import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_SECCIONES = 'ALL_SECCIONES';
export const ACTIVO_SECCIONES = 'ACTIVO_SECCIONES';
export const LOADING_ALL_SECCIONES = 'LOADING_ALL_SECCIONES';
export const PARAMS_SECCIONES = 'PARAMS_SECCIONES';
export const SEARCH_SECCIONES = 'SEARCH_SECCIONES';

const initialState = {
  all: [],
  search: [],
  activo: null,
  loadingAll: false,
  params: {},
};

export const seccionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_SECCIONES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_SECCIONES:
      return {
        ...state,
        activo: action.payload,
      };
    case SEARCH_SECCIONES:
      return {
        ...state,
        search: action.payload,
      };
    case LOADING_ALL_SECCIONES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_SECCIONES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
